import React from "react";
import Select, {
  ActionMeta,
  MultiValue,
  components,
  GroupBase,
  MultiValueRemoveProps,
  StylesConfig,
} from "react-select";
import chroma from "chroma-js";

import { PodcastSelectionInterface } from "./PodcastSelectionInterface";
import "./PodcastSelector.css";

export function PodcastSelector(
  allPodcasts: PodcastSelectionInterface[],
  selectedPodcasts: PodcastSelectionInterface[],
  setSelectedPodcasts: (state: PodcastSelectionInterface[]) => void
): JSX.Element {
  const handleChange = (
    newValue: MultiValue<PodcastSelectionInterface>,
    actionMeta: ActionMeta<PodcastSelectionInterface> // eslint-disable-line @typescript-eslint/no-unused-vars
  ) => {
    // newValue is a readonly array of the selected options. copy it to state.
    setSelectedPodcasts([...newValue]);
  };

  /* eslint-disable no-nested-ternary, @typescript-eslint/naming-convention */
  const colourStyles: StylesConfig<PodcastSelectionInterface, true> = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? chroma.contrast(color, "white") > 2
            ? "white"
            : "black"
          : data.color,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css(),
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: data.color,
      ":hover": {
        backgroundColor: data.color,
        color: "white",
      },
    }),
  };
  // re-enable eslint
  /* eslint-enable no-nested-ternary, @typescript-eslint/naming-convention */

  const multiValueRemove = (
    props: JSX.IntrinsicAttributes &
      MultiValueRemoveProps<
        PodcastSelectionInterface,
        boolean,
        GroupBase<PodcastSelectionInterface>
      >
  ) => {
    // don't allow the user to remove the last selected podcast:
    if (selectedPodcasts.length === 1) {
      return null;
    }
    return <components.MultiValueRemove {...props} />;
  };

  return (
    <div className="podcast-selector">
      <Select
        isMulti
        isClearable={false}
        // styles={customStyles}
        options={allPodcasts}
        value={selectedPodcasts}
        onChange={handleChange}
        components={{ MultiValueRemove: multiValueRemove }}
        styles={colourStyles}
      />
    </div>
  );
}
